import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Astro
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time

        // Resource
        this.resource = this.resources.items.astroModel

        this.setModel()
        this.setAnimation()
    }

    setModel()
    {
        this.model = this.resource.scene
        this.scene.add(this.model)
        this.model.position.x = 23.4 + ($fx.rand() * 0.3)
        this.model.position.y = 3.7 + ($fx.rand() * 0.3)
        this.model.position.z = 23.4 + ($fx.rand() * 0.3)
        this.model.scale.set(0.01, 0.01, 0.01)
        this.model.lookAt(new THREE.Vector3(0, 0, 0))
        this.model.traverse((child) => {
            if(child.isMesh) {
                child.material = new THREE.MeshBasicMaterial({ color: 0x000000, wireframe: true })
            }
        });
        this.model.layers.enable(1)
    }

    setAnimation()
    {
        this.animation = {}
        
        // Mixer
        this.animation.mixer = new THREE.AnimationMixer(this.model)
        
        // Actions
        this.animation.actions = {}
        
        this.animation.actions.idle = this.animation.mixer.clipAction(this.resource.animations[0])
        
        this.animation.actions.current = this.animation.actions.idle
        this.animation.actions.current.play()
    }

    update()
    {
        this.animation.mixer.update(this.time.delta * 0.001)
    }
}